import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Rare Frequency Works',
    description: 'An independent studio building small, private tools: DOCSCRUB for PDFs, free image tools, and Morpho Radar for DeFi developers.',
    placeholder: '',
    url: getOrigin()
}

export const NAV_LINKS = [
    { label: 'DOCSCRUB', href: '/docscrub' },
    { label: 'Morpho Radar', href: '/morpho-radar' },
    { label: 'Free Tools', href: '/tools' },
    { label: 'Guides', href: '/guides' },
    { label: 'About', href: '/about' },
    { label: 'Support', href: '/support' }
]
